import ReviewsSlider from "../../reviewsSlider";
import { REVIEWS } from "../constants";

import styles from "./styles.module.scss";

const ReviewsBlock = () => {
  return (
    <section className={styles.Container}>
      <div className="container">
        <div className={styles.ReviewsBlock}>

          <h2>Первые получатели</h2>
          <ReviewsSlider reviews={REVIEWS} />

        </div>
      </div>
    </section>
  );
};

export default ReviewsBlock;
